export const FeedbackStepsStatus = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  DONE: 'done',
};
